<template>
    <v-container>
        <v-tabs v-model="tab">
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab>
            Profile
          </v-tab>
          <v-tab>
            Payment
          </v-tab>
          <v-tabs-items v-model="tab">
          <v-tab-item>
            <UserProfile />
          </v-tab-item>
          <v-tab-item>
            <UserCard />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      </v-container>
</template>

<script>
import UserCard from "@/components/UserCard";
import UserProfile from "@/components/UserProfile"

export default {
  name: "Profile",
  components: { UserCard, UserProfile },
  data() {
    return {
      tab: ''
    }
  }
}
</script>

<style scoped>

</style>